document.addEventListener("DOMContentLoaded", function () {
  const button1 = document.getElementById("button-1");
  const buttonListItem = document.querySelector(".button-list-item");
  const floatSvgs = document.querySelectorAll(".float-svg");
  const floatContainer = document.querySelector(".float-svg-container");
  const content = document.querySelector(".section-healthcare__content");
  const sectionContent = document.querySelector(".section__content");
  const modalImg = document.querySelector(".section-healthcare__modal-img");

  let originalParent = null;
  let originalNextSibling = null;
  let originalPreviousSibling = null;
  let originalIndex = null;
  let isInitialized = false;
  let currentBreakpoint = null;
  let isExpanded = false;

  function getCurrentBreakpoint() {
    return window.innerWidth <= 1079 ? "mobile" : "desktop";
  }

  function initializeOriginalPosition() {
    if (!isInitialized && buttonListItem) {
      originalParent = buttonListItem.parentNode;
      originalNextSibling = buttonListItem.nextSibling;
      originalPreviousSibling = buttonListItem.previousElementSibling;

      const children = Array.from(originalParent.children);
      originalIndex = children.indexOf(buttonListItem);

      isInitialized = true;
    }
  }

  function resetElementStyles() {
    if (buttonListItem) {
      buttonListItem.style.position = "";
      buttonListItem.style.bottom = "";
    }
  }

  function moveButtonListItem() {
    if (!buttonListItem || !sectionContent) {
      return;
    }

    const newBreakpoint = getCurrentBreakpoint();

    if (currentBreakpoint === newBreakpoint && isInitialized) {
      return;
    }

    initializeOriginalPosition();

    if (newBreakpoint === "mobile") {
      if (buttonListItem.parentNode !== sectionContent) {
        resetElementStyles();

        sectionContent.appendChild(buttonListItem);
        buttonListItem.style.position = "relative";
        buttonListItem.style.bottom = "auto";

        if (content) {
          content.style.paddingTop = "0px";
          content.style.paddingBottom = "0px";
        }
      }
    } else {
      if (originalParent && buttonListItem.parentNode !== originalParent) {
        resetElementStyles();

        let restored = false;

        if (
          originalNextSibling &&
          originalNextSibling.parentNode === originalParent &&
          document.contains(originalNextSibling) &&
          originalNextSibling.nodeType === Node.ELEMENT_NODE
        ) {
          originalParent.insertBefore(buttonListItem, originalNextSibling);
          restored = true;
        } else if (
          originalPreviousSibling &&
          originalPreviousSibling.parentNode === originalParent &&
          document.contains(originalPreviousSibling)
        ) {
          if (originalPreviousSibling.nextSibling) {
            originalParent.insertBefore(
              buttonListItem,
              originalPreviousSibling.nextSibling
            );
          } else {
            originalParent.appendChild(buttonListItem);
          }
          restored = true;
        } else if (originalIndex !== null && originalIndex >= 0) {
          const children = Array.from(originalParent.children);
          if (originalIndex < children.length) {
            originalParent.insertBefore(
              buttonListItem,
              children[originalIndex]
            );
          } else {
            originalParent.appendChild(buttonListItem);
          }
          restored = true;
        }

        if (!restored) {
          originalParent.appendChild(buttonListItem);
        }

        buttonListItem.style.position = "";
        buttonListItem.style.bottom = "";
      }
    }

    currentBreakpoint = newBreakpoint;
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  moveButtonListItem();

  function handleResize() {
    const wasExpanded = isExpanded;

    moveButtonListItem();

    if (wasExpanded && buttonListItem) {
      setTimeout(() => {
        const scrollHeight = buttonListItem.scrollHeight;
        buttonListItem.style.maxHeight = scrollHeight + "px";

        const currentBreakpointAfterResize = getCurrentBreakpoint();
        if (content) {
          if (currentBreakpointAfterResize === "desktop") {
            content.style.paddingTop = "163px";
          } else {
            content.style.paddingTop = "0px";
            content.style.paddingBottom = "0px";
          }
        }
      }, 50);
    }
  }

  window.addEventListener("resize", debounce(handleResize, 100));

  if (button1 && buttonListItem) {
    buttonListItem.style.maxHeight = "0";
    buttonListItem.style.overflow = "hidden";
    buttonListItem.style.transition = "max-height 0.4s ease, opacity 0.3s ease";
    buttonListItem.style.opacity = "0";

    button1.addEventListener("click", function (e) {
      e.preventDefault();

      const currentBreakpointForClick = getCurrentBreakpoint();

      if (isExpanded) {
        buttonListItem.style.maxHeight = "0";
        buttonListItem.style.opacity = "0";
        floatSvgs.forEach((svg) => {
          svg.style.transition = "opacity 0.3s ease";
          svg.style.opacity = "1";
        });
        if (floatContainer) floatContainer.style.display = "block";

        if (content) {
          if (currentBreakpointForClick === "mobile") {
            content.style.paddingTop = "0px";
            content.style.paddingBottom = "0px";
          } else {
            content.style.paddingTop = "";
            content.style.paddingBottom = "";
          }
        }

        modalImg.style.opacity = "0";

        isExpanded = false;
      } else {
        const scrollHeight = buttonListItem.scrollHeight;
        buttonListItem.style.maxHeight = scrollHeight + "px";
        buttonListItem.style.opacity = "1";
        floatSvgs.forEach((svg) => {
          svg.style.transition = "opacity 0.3s ease";
          svg.style.opacity = "0";
          if (modalImg) modalImg.style.opacity = "1";
        });
        if (floatContainer) floatContainer.style.display = "none";

        if (content) {
          if (currentBreakpointForClick === "desktop") {
            content.style.paddingTop = "163px";
          } else {
            content.style.paddingTop = "0px";
            content.style.paddingBottom = "0px";
          }
        }

        isExpanded = true;
      }
    });
  }
});
